import { ReportEntity } from '@app/domain/entities';
import type { IReportRepository } from '@app/domain/ports';
import { IndexedDbFactory } from '../factories/indexeddb-provider.factory';
import { BaseIndexDbRepository } from './base-indexdb.repository';

export class ReportRepository extends BaseIndexDbRepository<ReportEntity> implements IReportRepository {
  constructor(indexedDbFactory: IndexedDbFactory) {
    super(indexedDbFactory, 'reports');
  }

  async findAllByCreatedAt(descending = true): Promise<ReportEntity[]> {
    return this.executeStoreOperation('findAllByCreatedAt', { descending }, async (db) => {
      const reports = await db.reports.orderBy('createdAt').toArray();
      if (descending) reports.reverse();
      return reports;
    });
  }
}
